const carouselItems = [
  {
    title: '2026暑期档观影指南',
    desc: '从科幻巨制到温情动画，为你盘点今夏最值得期待的院线大片与流媒体新片，附观看顺序推荐。',
    tag: '编辑精选',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20marathon%20concept%20with%20warm%20golden%20sunset%20lighting%2C%20vintage%20film%20projector%20and%20outdoor%20screen%2C%20palm%20tree%20silhouettes%2C%20nostalgic%20drive-in%20theater%20aesthetic%2C%20rich%20amber%20and%20teal%20tones&width=900&height=500&seq=carousel-summer-guide&orientation=landscape',
  },
  {
    title: '华语科幻电影的黄金时代',
    desc: '从流浪地球到三体，华语科幻电影正在经历前所未有的爆发期。深度盘点近五年国产科幻佳作。',
    tag: '深度专题',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20science%20fiction%20cinematic%20landscape%2C%20futuristic%20cityscape%20with%20traditional%20elements%2C%20dramatic%20lighting%20with%20warm%20lanterns%20against%20neon%2C%20film%20poster%20aesthetic%2C%20grand%20scale&width=900&height=500&seq=carousel-scifi-era&orientation=landscape',
  },
  {
    title: '那些被低估的冷门佳作',
    desc: '豆瓣评分8.0以上但看过的人不多——这些藏在小众角落里的电影，每一部都是被时光遗忘的珍珠。',
    tag: '冷门推荐',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20hidden%20gems%20concept%20with%20old%20film%20reels%20on%20wooden%20shelves%2C%20warm%20vintage%20lighting%2C%20dust%20particles%20in%20sunbeam%2C%20nostalgic%20archive%20room%2C%20rich%20sepia%20and%20golden%20tones&width=900&height=500&seq=carousel-hidden-gems&orientation=landscape',
  },
  {
    title: '悬疑片爱好者的终极片单',
    desc: '从希区柯克到诺兰，从西班牙悬疑到韩国犯罪，50部让你屏住呼吸的高分悬疑电影一网打尽。',
    tag: '专题合集',
    img: 'https://readdy.ai/api/search-image?query=Moody%20film%20noir%20aesthetic%20with%20venetian%20blind%20shadows%20casting%20stripes%2C%20detective%20desk%20with%20warm%20lamp%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20rich%20contrast%20with%20deep%20amber%20tones&width=900&height=500&seq=carousel-mystery-list&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-foreground-500 text-sm">深度策划的影视专题内容，发现更多好片</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {carouselItems.map((item, i) => (
              <div
                key={i}
                className="group relative bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[16/9] md:aspect-[2/1] overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
                  <div className="absolute top-4 left-4">
                    <span className="inline-block px-3 py-1 bg-primary-500/90 text-background-50 text-xs font-semibold rounded-md">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                    <h3 className="font-heading font-bold text-background-50 text-lg md:text-xl mb-2">{item.title}</h3>
                    <p className="text-background-50/70 text-xs md:text-sm leading-relaxed line-clamp-2">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}